import { IBaseDtoType } from './common.type'

export interface ISettingsRespDto extends IBaseDtoType {
  sign_up_enabled: boolean
  scan_to_earn_enabled: boolean
  show_journey_home_page: boolean

  traicy_definition: string
  traicy_post: string
  traicy_post_definition_2: string
  traicy_post_2: string
  traicy_post_definition_3: string
  traicy_post_3: string
  traicy_post_definition_4: string
  traicy_post_4: string

  traicy_definition_hash_tag_reply: string
  traicy_hash_tag_reply: string
  traicy_definition_mentions_reply: string
  traicy_hash_tag_list: string[]
  traicy_mentions_reply: string
  traicy_definition_followed_reply: string
  traicy_followed_reply: string
  traicy_image_definition_followed_reply: string
  traicy_image_followed_reply: string
  traicy_definition_message_check: string
  traicy_message_check: string
  traicy_definition_chatbot: string
  traicy_reply_chatbot: string

  traicy_image_with_text_definition: string
  traicy_image_with_text: string
  traicy_image_with_text_definition_2: string
  traicy_image_with_text_2: string
  traicy_image_with_text_definition_3: string
  traicy_image_with_text_3: string
  traicy_image_with_text_definition_4: string
  traicy_image_with_text_4: string

  scan_to_earn_definition_media_validation: string
  scan_to_earn_media_validation: string
  scan_to_earn_definition_product_name: string
  scan_to_earn_product_name: string
  scan_to_earn_definition_company_name: string
  scan_to_earn_company_name: string
  scan_to_earn_definition_summary: string
  scan_to_earn_summary: string
  scan_to_earn_definition_impacts: string
  scan_to_earn_impacts: string
  scan_to_earn_definition_product_type: string
  scan_to_earn_product_type: string
  scan_to_earn_definition_account_info: string
  scan_to_earn_account_info: string

  language_translation_definition: string
  language_translation: string
  main_entities_descriptions_definition: string
  main_entities_descriptions: string

  tg_bot_approved_scans_daily_summary_message: string
  tg_bot_approved_scan_message: string

  tg_approved_scans_daily_summary_chats: string[]
  tg_scan_approved_chats: string[]
  tg_manual_message_chats: string[]

  trackfi_definition_structured_data: string
  trackfi_structured_data: string
  trackfi_definition_followed_reply: string
  trackfi_followed_reply: string
  trackfi_users_to_follow: string[]
  trackfi_enable_tweets_reply: boolean
  trackfi_definition_quote_reply: string
  trackfi_quote_reply: string
  trackfi_enable_tweets_quote: boolean

  models_payload: ISettingsModelsPayload
  images_payload: ISettingsImagesPayload
  tools_payload: ISettingsToolsPayload
  description_entity_payload: ISettingsDescriptionEntityPayload
  tg_send_msg_permissions_payload: ISettingsTgSendMsgPermissionsPayload
  traicy_posts_payload: ISettingsTraicyPostsPayload
}

export interface ISettingsSignupRespDto {
  sign_up_enabled: boolean
}

export interface IUpdateSettingsSignupDto {
  enabled: boolean
}

export interface IUpdateSettingsSwitchDto {
  enabled: boolean
}

export interface IUpdateTraicyDefinitionDto {
  text: string
  field: ESettingsPromptFields
}

export interface IUpdateListDto {
  list: string[]
  field: ESettingsArrayFields
}

export interface ISendTgCustomMessageDto {
  message: string
}

export interface IUpdateModelsPayloadDto {
  model: string
  field: ESettingsModelOrToolFields
}

export interface IUpdateToolsPayloadDto {
  tool: Partial<ISettingsTool>
  field: ESettingsModelOrToolFields
}

export interface IUpdateTgSendMessagePermissionsDto {
  value: boolean
  field: ESettingsTgSendMsgPermissionsFields
}

export interface IUpdateTraicyPostsPayloadDto {
  value: boolean
  field: ETraicyPostsPayloadFields
}

export type IUpdateSettingFieldsDto = Partial<ISettingsRespDto>

export interface IUpdateDescriptionEntityPayloadDto {
  desc: Partial<ISettingsDescriptionEntityPayload>
}

export interface IUpdateTraicyHashtagsListDto {
  list: string[]
}

export enum ESettingsPromptFields {
  TRAICY_DEFINITION = 'traicy_definition',
  TRAICY_POST = 'traicy_post',
  TRAICY_POST_DEFINITION_2 = 'traicy_post_definition_2',
  TRAICY_POST_2 = 'traicy_post_2',
  TRAICY_POST_DEFINITION_3 = 'traicy_post_definition_3',
  TRAICY_POST_3 = 'traicy_post_3',
  TRAICY_POST_DEFINITION_4 = 'traicy_post_definition_4',
  TRAICY_POST_4 = 'traicy_post_4',

  TRAICY_HASHTAG_REPLY = 'traicy_hash_tag_reply',
  TRAICY_DEFINITION_HASHTAG_REPLY = 'traicy_definition_hash_tag_reply',
  TRAICY_DEFINITION_MENTIONS_REPLY = 'traicy_definition_mentions_reply',
  TRAICY_MENTIONS_REPLY = 'traicy_mentions_reply',
  TRAICY_DEFINITION_FOLLOWED_REPLY = 'traicy_definition_followed_reply',
  TRAICY_FOLLOWED_REPLY = 'traicy_followed_reply',
  TRAICY_IMAGE_DEFINITION_FOLLOWED_REPLY = 'traicy_image_definition_followed_reply',
  TRAICY_IMAGE_FOLLOWED_REPLY = 'traicy_image_followed_reply',
  TRAICY_DEFINITION_MESSAGE_CHECK = 'traicy_definition_message_check',
  TRAICY_MESSAGE_CHECK = 'traicy_message_check',
  TRAICY_DEFINITION_CHATBOT = 'traicy_definition_chatbot',
  TRAICY_REPLY_CHATBOT = 'traicy_reply_chatbot',

  TRAICY_IMAGE_WITH_TEXT_DEFINITION = 'traicy_image_with_text_definition',
  TRAICY_IMAGE_WITH_TEXT = 'traicy_image_with_text',
  TRAICY_IMAGE_WITH_TEXT_DEFINITION_2 = 'traicy_image_with_text_definition_2',
  TRAICY_IMAGE_WITH_TEXT_2 = 'traicy_image_with_text_2',
  TRAICY_IMAGE_WITH_TEXT_DEFINITION_3 = 'traicy_image_with_text_definition_3',
  TRAICY_IMAGE_WITH_TEXT_3 = 'traicy_image_with_text_3',
  TRAICY_IMAGE_WITH_TEXT_DEFINITION_4 = 'traicy_image_with_text_definition_4',
  TRAICY_IMAGE_WITH_TEXT_4 = 'traicy_image_with_text_4',

  SCAN_TO_EARN_DEFINITION_MEDIA_VALIDATION = 'scan_to_earn_definition_media_validation',
  SCAN_TO_EARN_MEDIA_VALIDATION = 'scan_to_earn_media_validation',
  SCAN_TO_EARN_DEFINITION_PRODUCT_NAME = 'scan_to_earn_definition_product_name',
  SCAN_TO_EARN_PRODUCT_NAME = 'scan_to_earn_product_name',
  SCAN_TO_EARN_DEFINITION_COMPANY_NAME = 'scan_to_earn_definition_company_name',
  SCAN_TO_EARN_COMPANY_NAME = 'scan_to_earn_company_name',
  SCAN_TO_EARN_DEFINITION_SUMMARY = 'scan_to_earn_definition_summary',
  SCAN_TO_EARN_SUMMARY = 'scan_to_earn_summary',
  SCAN_TO_EARN_DEFINITION_IMPACTS = 'scan_to_earn_definition_impacts',
  SCAN_TO_EARN_IMPACTS = 'scan_to_earn_impacts',
  SCAN_TO_EARN_DEFINITION_PRODUCT_TYPE = 'scan_to_earn_definition_product_type',
  SCAN_TO_EARN_PRODUCT_TYPE = 'scan_to_earn_product_type',
  SCAN_TO_EARN_DEFINITION_ACCOUNT_INFO = 'scan_to_earn_definition_account_info',
  SCAN_TO_EARN_ACCOUNT_INFO = 'scan_to_earn_account_info',

  LANGUAGE_TRANSLATION_DEFINITION = 'language_translation_definition',
  LANGUAGE_TRANSLATION = 'language_translation',
  MAIN_ENTITIES_DESCRIPRIONS_DEFINITION = 'main_entities_descriptions_definition',
  MAIN_ENTITIES_DESCRIPRIONS = 'main_entities_descriptions',
  TG_BOT_APPROVED_SCANS_DAILY_SUMMARY_MESSAGE = 'tg_bot_approved_scans_daily_summary_message',
  TG_BOT_APPROVED_SCAN_MESSAGE = 'tg_bot_approved_scan_message',

  TRACKFI_DEFINITION_STRUCTURED_DATA = 'trackfi_definition_structured_data',
  TRACKFI_STRUCTURED_DATA = 'trackfi_structured_data',
  TRACKFI_DEFINITION_FOLLOWED_REPLY = 'trackfi_definition_followed_reply',
  TRACKFI_FOLLOWED_REPLY = 'trackfi_followed_reply',
  TRACKFI_DEFINITION_QUOTE_REPLY = 'trackfi_definition_quote_reply',
  TRACKFI_QUOTE_REPLY = 'trackfi_quote_reply',
}

export enum ESettingsArrayFields {
  TG_APPROVED_SCANS_DAILY_SUMMARY_CHATS = 'tg_approved_scans_daily_summary_chats',
  TG_SCAN_APPROVED_CHATS = 'tg_scan_approved_chats',
  TG_MANUAL_MESSAG_CHATS = 'tg_manual_message_chats',
  TRACKFI_USERS_TO_FOLLOW = 'trackfi_users_to_follow',
}
export enum ESettingsModelOrToolFields {
  X_BOT_POST = 'x_bot_post',
  X_BOT_POST_2 = 'x_bot_post_2',
  X_BOT_POST_3 = 'x_bot_post_3',
  X_BOT_POST_4 = 'x_bot_post_4',
  X_BOT_HASHTAG_REPLY = 'x_bot_hashtag_reply',
  X_BOT_MENTIONS_REPLY = 'x_bot_mentions_reply',
  X_BOT_FOLLOWED_REPLY = 'x_bot_followed_reply',
  WEB_CHAT_BOT = 'web_chat_bot',
  SCAN_TO_EARN_VALIDATION = 'scan_to_earn_validation',
  SCAN_TO_EARN_PRODUCT_NAME = 'scan_to_earn_product_name',
  SCAN_TO_EARN_COMPANY_NAME = 'scan_to_earn_company_name',
  SCAN_TO_EARN_SUMMARY = 'scan_to_earn_summary',
  SCAN_TO_EARN_IMPACTS = 'scan_to_earn_impacts',
  SCAN_TO_EARN_PRODUCT_TYPE = 'scan_to_earn_product_type',
  SCAN_TO_EARN_ACCOUNT_INFO = 'scan_to_earn_account_info',
  LANGUAGE_TRANSLATION = 'language_translation',
  TRAICY_IMAGE_WITH_TEXT = 'traicy_image_with_text',
  TRAICY_IMAGE_WITH_TEXT_2 = 'traicy_image_with_text_2',
  TRAICY_IMAGE_WITH_TEXT_3 = 'traicy_image_with_text_3',
  TRAICY_IMAGE_WITH_TEXT_4 = 'traicy_image_with_text_4',
  TRAICY_IMAGE_FOLLOWED_REPLY = 'traicy_image_followed_reply',
  MAIN_ENTITIES_DESCRIPRIONS = 'main_entities_descriptions',
  TRACKFI_STRUCTURED_DATA = 'trackfi_structured_data',
  TRACKFI_FOLLOWED_REPLY = 'trackfi_followed_reply',
  TRACKFI_QUOTE_REPLY = 'trackfi_quote_reply',
}

export interface IHashTagsSettingsForm {
  hashTags: string[]
  newTag: string
}

export interface ISettingsModelsPayload {
  x_bot_post: string
  x_bot_post_2: string
  x_bot_post_3: string
  x_bot_post_4: string

  x_bot_hashtag_reply: string
  x_bot_mentions_reply: string
  x_bot_followed_reply: string
  web_chat_bot: string
  scan_to_earn_validation: string
  scan_to_earn_product_name: string
  scan_to_earn_company_name: string
  scan_to_earn_summary: string
  scan_to_earn_impacts: string
  scan_to_earn_product_type: string
  scan_to_earn_account_info: string
  language_translation: string
  traicy_image_with_text: string
  traicy_image_with_text_2: string
  traicy_image_with_text_3: string
  traicy_image_with_text_4: string
  traicy_image_followed_reply: string
  main_entities_descriptions: string
  trackfi_structured_data: string
  trackfi_followed_reply: string
  trackfi_quote_reply: string
}

export enum ESettingsImagesFields {
  IMAGE_1 = 'image_1',
  IMAGE_2 = 'image_2',
  IMAGE_3 = 'image_3',
  IMAGE_4 = 'image_4',
  IMAGE_5 = 'image_5',
}

export interface ISettingsImagesPayload {
  image_1: string
  image_2: string
  image_3: string
  image_4: string
  image_5: string
}

export interface IUpdateSettingsImagesPayloadDto {
  value: string
  field: ESettingsImagesFields
}

export interface ISettingsToolsPayload {
  x_bot_post: ISettingsTool
  x_bot_post_2: ISettingsTool
  x_bot_post_3: ISettingsTool
  x_bot_post_4: ISettingsTool
  x_bot_hashtag_reply: ISettingsTool
  x_bot_mentions_reply: ISettingsTool
  x_bot_followed_reply: ISettingsTool
  web_chat_bot: ISettingsTool
  scan_to_earn_validation: ISettingsTool
  scan_to_earn_product_name: ISettingsTool
  scan_to_earn_company_name: ISettingsTool
  scan_to_earn_summary: ISettingsTool
  scan_to_earn_impacts: ISettingsTool
  scan_to_earn_product_type: ISettingsTool
  scan_to_earn_account_info: ISettingsTool
  language_translation: ISettingsTool
  traicy_image_with_text: ISettingsTool
  traicy_image_with_text_2: ISettingsTool
  traicy_image_with_text_3: ISettingsTool
  traicy_image_with_text_4: ISettingsTool
  traicy_image_followed_reply: ISettingsTool
  main_entities_descriptions: ISettingsTool
  trackfi_structured_data: ISettingsTool
  trackfi_followed_reply: ISettingsTool
  trackfi_quote_reply: ISettingsTool
}

export interface ISettingsTool {
  web_search: boolean
  file_search: boolean
  vector_store_ids: string[]
}

export interface ISettingsDescriptionEntityPayload {
  journey: string
  step: string
  impact: string
  product: string
  account: string
}

export interface ISettingsTgSendMsgPermissionsPayload {
  approved_scans_daily_summary: boolean
  scan_approval_notification: boolean
  mention_reply: boolean
}

export enum ESettingsTgSendMsgPermissionsFields {
  APPROVED_DAILY_SUMMARY = 'approved_scans_daily_summary',
  SCAN_APPPROVAL_NOTIFICATION = 'scan_approval_notification',
  MENTION_REPLY = 'mention_reply',
}

export enum EXBotPromptFields {
  X_BOT_POST = 'x_bot_post',
  X_BOT_POST_2 = 'x_bot_post_2',
  X_BOT_POST_3 = 'x_bot_post_3',
  X_BOT_POST_4 = 'x_bot_post_4',
}

export interface ISettingsTraicyPostsPayload {
  x_post_image: boolean
  x_post_image_2: boolean
  x_post_image_3: boolean
  x_post_image_4: boolean
  x_followed_reply_image: boolean
}

export enum ETraicyPostsPayloadFields {
  X_BOT_POST = 'x_post_image',
  X_BOT_POST_2 = 'x_post_image_2',
  X_BOT_POST_3 = 'x_post_image_3',
  X_BOT_POST_4 = 'x_post_image_4',
  X_BOT_FOLLOWED_REPLY = 'x_followed_reply_image',
}
